<template>
    <v-simple-table dense :class="classList" :style="style">
        <colgroup v-if="findSlot('colgroup')">
            <slot name="colgroup" />
        </colgroup>

        <thead v-if="findSlot('head')" class="app-table-header">
            <slot name="head" />
        </thead>
        <thead v-else-if="!_.isEmpty(headers)" class="app-table-header">
            <tr>
                <th v-for="(headerValue, col) in headers" :key="`thead-${col}`">
                    {{ headerValue }}
                </th>
            </tr>
        </thead>
        <thead v-else-if="headersFromItemKeys" class="app-table-header">
            <tr>
                <th v-for="(headerValue, col) in itemKeyHeaders" :key="`thead-${col}`">
                    {{ headerValue }}
                </th>
            </tr>
        </thead>
        <tbody v-if="findSlot('body')">
            <slot name="body" />
        </tbody>
        <tbody v-else>
            <tr v-for="(item, row) in items" :key="`tbody-${row}`">
                <td v-for="(itemValue, col) in item" :key="`tbody-${row}-${col}`">
                    {{ itemValue }}
                </td>
            </tr>
        </tbody>
    </v-simple-table>
</template>

<script>
export default {
    name: 'AppTableSimple',
    props: {
        items: {
            type: Array,
            default: () => []
        },
        headers: {
            type: Array,
            default: () => []
        },
        outlined: {
            type: Boolean,
            default: false
        },
        tableLayout: {
            type: String,
            default: 'fixed'
        },
        columnWidthAuto: {
            type: Boolean,
            default: false
        },
        maxHeight: {
            type: String,
            default: 'auto'
        },
        noOverflow: {
            type: Boolean,
            default: false
        },
        headersFromItemKeys: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        classList() {
            let classList = ['app-table', 'app-table-simple', `app-table--${this.uuid}`];

            if (this.outlined) {
                classList.push('app-table--outlined');
            }

            if (this.tableLayout) {
                classList.push(`app-table--layout--${this.tableLayout}`);
            }

            if (this.columnWidthAuto) {
                classList.push(`app-table--column-width-auto`);
            }

            return classList;
        },
        itemKeyHeaders() {
            if (!this.headersFromItemKeys) {
                return [];
            }

            if (!this.items) {
                return [];
            }

            if (Array.isArray(this.items) && !this.items.length) {
                return [];
            }

            return Object.keys(this.items[0]);
        },
        style() {
            return {
                'max-height': this.maxHeight ? this.maxHeight : false,
                'overflow-y': !this.noOverflow && this.maxHeight && this.maxHeight !== 'auto' ? 'scroll' : 'hidden',
                overflow: this.noOverflow ? 'hidden' : false
            };
        }
    }
};
</script>
